import '../scss/top.scss';


var slideWrapper = $('.mv-slider'),
    lazyImages = slideWrapper.find('.mv-slider-block__img'),
    lazyCounter = 0;

// When the slide is changing
function changeSlide(slick, control){
  var currentSlide, slideType, video;

  currentSlide = slick.find('.slick-current');
  slideType = currentSlide.attr('class').split(' ')[1];

  if (slideType === 'video') {
    video = currentSlide.find('video').get(0);
    if (video != null) {
      if (control === 'play'){
        video.play();
        video.currentTime = 0;
      } else {
        video.pause();
      }
    }
  }
}





$(function(){
  // Initialize
  slideWrapper.on('init', function(slick){
    slick = $(slick.currentTarget);
    setTimeout(function(){
      changeSlide(slick,'play');
    }, 1000);
  });
  slideWrapper.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    if(nextSlide > 0 ) {
      $(this).slick('slickSetOption', 'autoplaySpeed', 5000);
    }
    slick = $(slick.$slider);
    changeSlide(slick,'pause');
  });
  slideWrapper.on('afterChange', function(event, slick) {
    slick = $(slick.$slider);
    changeSlide(slick,'play');
  });
  slideWrapper.on('lazyLoaded', function(event, slick, image, imageSource) {
    lazyCounter++;
    if (lazyCounter === lazyImages.length){
      lazyImages.addClass('show');
      slideWrapper.slick('slickPlay');
    }
  });

  // スライダ
  slideWrapper.slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 7000,
    cssEase:'cubic-bezier(0.87, 0.03, 0.41, 0.9)',
    dots: true,
    fade: true,
    infinite: true,
    lazyLoad: 'progressive',
    pauseOnHover: false,
    speed: 2000,
    customPaging: function(slick,index) {
      //2022-09-27aa
      var targetTitle = slick.$slides.eq(index).find('.mv-slider-block__ttl .txt').html();
      return '<span>' + targetTitle + '</span>';
    }
  })
  .on('beforeChange',function(event, slick, currentSlide, nextSlide){
    if(nextSlide > 0 ) {
      $(this).slick('slickSetOption', 'autoplaySpeed', 5000);
    }
  });
  slideWrapper.on('touchmove', function(event, slick, currentSlide, nextSlide){
    slideWrapper.slick('slickPlay');
  });


  if ( $('.next-game')[0] ) {
    $('.next-game-list').slick({
      autoplay: false,
      centerMode: true,
      centerPadding: '9.4%',
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.next-game-date',
      dots: false,
      pauseOnHover: false,
      prevArrow: '.next-game-contents__arrow--prev',
      nextArrow: '.next-game-contents__arrow--next',
      responsive: [
        {
          breakpoint: 1180,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '6.67vw'
          }
        }
      ]
    });
    $('.next-game-date').slick({
      arrows: false,
      autoplay: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.next-game-list',
      dots: false,
      pauseOnHover: false,
      focusOnSelect: true,
      slide: 'p'
    });
    if ( !($('.game-result').length) ) {
      $('.next-game').addClass('is-full');
      $('.next-game-list').slick('slickSetOption', {
        slidesToShow: 2,
        slidesToScroll: 2,
      });
    }
  }

  $('.movie-list').slick({
    arrows: false,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1180,
        settings: {
          autoplay: true,
          speed: 800,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          autoplay: true,
          speed: 800,
          centerMode: true,
          centerPadding: '8%',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  // お知らせ
  $('.js-tab-item').on('click', function() {
    var num = $('.js-tab-item').index(this);
    $('.js-tab-item').removeClass('is-current');
    $(this).addClass('is-current');
    $('.js-tab-contents').removeClass('is-active');
    $('.js-tab-contents').eq(num).addClass('is-active');
  });
});

// 赤い線
$(window).on('load scroll', function() {
  var y = $(window).scrollTop();
  var h = $(window).innerHeight();
  $('.js-scroll-action').each(function() {
    if ( ( y + ( h * 0.8 ) ) > $(this).offset().top ) {
      $(this).addClass('is-action');
    };
  });
});



// var swiper = new Swiper('.swiper-container', {
//   loop: true,
//   spaceBetween: 44,
//   pagination: {
//     el: '.next-game-date',
//     type: 'custom',
//     dynamicBullets: true,
//     dynamicMainBullets: 3,
//     clickable: true,
//     bulletActiveClass: 'is-current'
//   },
//   navigation: {
//     nextEl: '.next-game-contents__arrow--next',
//     prevEl: '.next-game-contents__arrow--prev',
//   }
// });
